import React from 'react';
import PropTypes from 'prop-types';
import { PropsContext } from '@uhg-abyss/web/hooks/usePropsContext/PropsContext';

import { ProviderSelect } from './ProviderSelect';

export const Widget = (props) => {
  const widgetProps = { ...props };

  return (
    <PropsContext.Provider value={widgetProps}>
      <ProviderSelect {...props} />
    </PropsContext.Provider>
  );
};

Widget.displayName = 'utility/ProviderSelect';

Widget.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    user: PropTypes.shape({}).isRequired,
    width: PropTypes.number,
    isDropdownHidden: PropTypes.bool,
    saveDisabled: PropTypes.bool,
  }),
  events: PropTypes.shape({}),
  styles: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {
    title: 'Provider Select',
  },
  events: null,
  styles: null,
};
